<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <Validate :form="form" v-if="email_view"></Validate>
      <form v-else class="app-pay-form" @submit.prevent="withdrawal">
          <div class="col">
            <div class="inline-form">
              <label>Papara No</label>
				      <input type="text" v-model="form.account_no" placeholder="Papara No yazınız" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Çekim tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
					<div class="col" v-if="check_checkbox">
						<div class="inline-form">
							<label>Kabul ediyorum</label>
							<input type="checkbox" checked='checked' v-model="form.accept_rule"/>
						</div>
					</div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Çek'" />
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'
  import Validate from '../../../../components/User/Pay/Validate'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form: {
            withdraw_validation_code:null,
            amount: null,
            account_no : null,
        },
        loading: false,
        btnLoading: false,
        check_checkbox: false,
        email_view: false,
      }
    },
    created(){
    },
    methods:{
      withdrawal(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/withdrawal/hizlipapara/create', this.form)
        .then((response) => {
          if(response.data.email_view){
            this.email_view = true
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            return false
          }
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          }
        })
        .catch((err) => {
          if (err.response.data.check_checkbox){
            this.check_checkbox = true;
          }
          if(err.response.data.email_verification){
            this.$router.push({ name: 'User', params: { section: 'security', payment: null } })
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Validate,
      Form
    }
  }

</script>
